<div class="container animated fadeInRight" *ngIf="!mostrarFormulario">
  <app-lfsa-card [innTemplate]="grid" [titulo]="'Mantenimiento de Tallas por Grupo'" [efecto]="true" [colapseName]="'grid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #grid>
    <div class="row">
      <div class="col-md-6">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
            No existen datos para la lista de Grupos de Tallas.
          </div>
          <div *ngIf="!listaVacia">
            <div class="row">
              <div [class]="'col-md-12'">
                <label><b>Grupos de Prendas</b></label>
              </div>
            </div>
            <div class="row">
              <div [class]="'col-md-12'">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarGrupo" id="quickFilter "
                  (keyup)="onQuickFilterChanged()" #quickFilter />
              </div>
            </div>
            <div [class]="'col-md-12'">
              <ag-grid-angular #agGrid class=" {{tallaGrupoModulo.agGrid.class}}" [ngStyle]="tallaGrupoModulo.agGrid.style"
                id="{{tallaGrupoModulo.agGrid.id}}" [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs"
                [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
                 (cellClicked)="callSizes($event)">
              </ag-grid-angular>
            </div>
            <div [class]="'col-md-12'">
              <label>&nbsp;</label><br>
              <button class="btn btn-warning btn-block" (click)="callModalCrearGrupoTalla()">Agregar Grupo de Talla</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <!-- AQUI SEGUNDA PARTE -->
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <div>
            <div class="row">
              <div [class]="'col-md-12'">
                <label><b>Tallas por Grupos de Prendas</b></label>
              </div>
            </div>
            <div class="row">
              <div [class]="'col-md-12'">
                <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscarSize" id="quickFilterSize"
                  (keyup)="onQuickFilterChangedFilter()" #quickFilterSize />
              </div>
            </div>
            <div [class]="'col-md-12'">
              <ag-grid-angular #agGrid class=" {{sizeModulo.agGrid.class}}" [ngStyle]="sizeModulo.agGrid.style"
                id="{{sizeModulo.agGrid.id}}" [frameworkComponents]="frameworkComponentsFiler " [columnDefs]="columnDefsFilter"
                [rowSelection]="rowSelectionFilter" [rowData]="rowDataFilter" (gridReady)="onGridReadyFilter($event)" [pagination]="true"
                >
              </ag-grid-angular>
            </div>
            <div [class]="'col-md-12'">
              <label>&nbsp;</label><br>
              <button class="btn btn-warning btn-block" (click)="callModalCrearTalla()">Agregar Talla</button>
            </div>
          </div>
        </div>
      </div>      
    </div>
  </ng-template>
</div>

<!-- MODAL CREAR GRUPO TALLA-->
<app-lfsa-modal [innTemplate]="enviarModalGrupoTalla" [titulo]="'Crear Grupo Talla'" [idButton]="'abrirModalGrupoTalla'" [idOpen]="'Modal'"
  [idClose]="'cerrarModalGrupoTalla'"></app-lfsa-modal>
<ng-template #enviarModalGrupoTalla>
  <form [formGroup]="formularioCrearGrupoTalla" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCrearGrupoTalla.get('grupoSz')"
          [placeholder]="'Codigó'" formControlName="grupoSz" [label]="'Ingrese Codigó*'" [type]="'text'" [id]="'grupoSz'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCrearGrupoTalla.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'descrp'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCrearGrupoTalla.invalid"
            (click)="agregarGrupoTalla()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL CREAR TALLA-->
<app-lfsa-modal [innTemplate]="enviarModalTalla" [titulo]="'Crear Talla'" [idButton]="'abrirModalTalla'" [idOpen]="'ModalTalla'"
  [idClose]="'cerrarModalTalla'"></app-lfsa-modal>
<ng-template #enviarModalTalla>
  <form [formGroup]="formularioCrearTalla" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCrearTalla.get('codSize')"
          [placeholder]="'Codigó'" formControlName="codSize" [label]="'Ingrese Codigó*'" [type]="'text'" [id]="'codSize'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioCrearTalla.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'descrp'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioCrearTalla.invalid"
            (click)="agregarTalla()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<!-- MODAL EDITAR TALLA-->
<app-lfsa-modal [innTemplate]="enviarModalTallaEdit" [titulo]="'Editar Talla'" [idButton]="'abrirModalTallaEdit'" [idOpen]="'ModalTallaEdit'"
  [idClose]="'cerrarModalTallaEdit'"></app-lfsa-modal>
<ng-template #enviarModalTallaEdit>
  <form [formGroup]="formularioEditTalla" novalidate class="form-group">
    <div class="row">
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioEditTalla.get('codSize')"
          [placeholder]="'Codigó'" formControlName="codSize" [label]="'Ingrese Codigó*'" [type]="'text'" [id]="'codSize'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-input  [claseLabel]="'letrasDanger'"  [mostrarImg]="false" [rutaImagen]="" [control]="formularioEditTalla.get('descrp')"
          [placeholder]="'Descripción'" formControlName="descrp" [label]="'Ingrese Descripción*'" [type]="'text'" [id]="'descrp'">
        </app-lfsa-input>
      </div>
      <div [class]="'col-md-12'">
        <app-lfsa-loading *ngIf="loading"></app-lfsa-loading>
        <div *ngIf="!loading">
          <label>&nbsp;</label><br>
          <button class="btn btn-success btn-block" [disabled]="formularioEditTalla.invalid"
            (click)="editarTalla()">Guardar</button>
        </div>
      </div>
    </div>
  </form>
</ng-template>